import classNames from "classnames";
import { get } from "lodash";
import { useState } from "react";
import { MdSupport } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { useMutation } from "shared/hooks/useApi";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import HelpModal from "./Modal";
import HelpContactModal from "./ModalContact";

function Help({ project, refetchProject }) {
  const [open, setOpen] = useState(false);
  const [updateProject] = useMutation(UPDATE_PROJECT);

  const onSubmit = (data) => {
    updateProject({
      variables: {
        where: { id: project?.id },
        data,
      },
    });
  };

  const onClose = () => setOpen(false);

  const onOpen = () => setOpen(true);

  const MODAL = {
    [true]: (
      <HelpContactModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
        refetchProject={refetchProject}
      />
    ),
    [false]: (
      <HelpModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <div className="amellis__help" onClick={onOpen}>
        <MdSupport size={isMobile ? 24 : 24} />
        <span
          className={classNames({
            hidden: !!get(project, "contact.user.firstname"),
          })}
        >
          Rappelez moi
        </span>
      </div>
      {MODAL[!!get(project, "contact.user.firstname")]}
    </>
  );
}

export default Help;
